import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { ENABLE_SVD_FLOW_DISCOVERY } from '@src/config/svd-flags'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'

/**
 * SVD rollout flag — the single source of truth for whether the SVD-native PDP flow is active.
 *
 * Reads the `RAMP_SVD_ROLLOUT` experiment (`show` = on), gated behind the program-wide kill-switch
 * `ENABLE_SVD_FLOW_DISCOVERY` (shared with the product-card flow — see `@src/config/svd-flags`), so
 * both SVD surfaces can be killed with one flip. This replaces the former `SvdOptionProvider` React
 * context: every `isSvd` branch across the buy box (option rendering, cascade, price, ATC gate,
 * custom fields, age gate) now derives from this one hook, so SVD can be ramped centrally via Statsig.
 *
 * The kill-switch is also passed as `shouldFetchExperiment`, so when it is `false` the hook never reads
 * the experiment — no Statsig exposure is logged. Every PDP (legacy included) calls this hook, so with
 * the program dark there is zero telemetry footprint on the existing flow.
 */
export function useIsSvdEnabled(): boolean {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.RAMP_SVD_ROLLOUT, ENABLE_SVD_FLOW_DISCOVERY)
  return (
    ENABLE_SVD_FLOW_DISCOVERY &&
    experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.RAMP_SVD_ROLLOUT]?.buckets?.show
  )
}
